<template>
    <section class="p-5 pt-10 md:pt-16">
        <div class="text-center">
            <div class="clear--sm"></div>
            <h2 class="pb-4" v-text="$t('RESET_PASSWORD_RESET')"></h2>
            <p class="py-1" v-text="$t('RESET_PASSWORD_NOTIFICATION_OKAY')"></p>
            <p class="py-1" v-text="$t('RESET_PASSWORD_JUST_HIT')"></p>
            <div class="clear--sm"></div>
            <p class="py-1 mb-12">
                <span v-html="$t('RESET_PASSWORD_HAVE_NOT')"></span>
                <router-link :to="{ name: 'forgot-password'}" class="link">
                    {{ $t('RESET_PASSWORD_HERE') }}
                </router-link>.
            </p>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ResetPasswordNotification',
};
</script>
